import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, useForm } from "react-hook-form";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { useQyCreateBranch } from "@factory/query/branch.query";
import { BranchFormRule, BranchFormSchema } from "@factory/form/form.rule";
import { branchFormDefault } from "@factory/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";

export function useNewBranch() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateBranch } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Branch is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addBranch, isLoading: isCreating } =
    useQyCreateBranch(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<BranchFormSchema>({
    defaultValues: branchFormDefault,
    resolver: zodResolver(BranchFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: BranchFormSchema) => {
    const formData = mapCreateBranch(form);
    addBranch(formData);
  };
  const handleValidateError = (err: FieldErrors<BranchFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
